export default "__VITE_ASSET__B6n4EoHM__"